import { useQuery } from '@tanstack/react-query';
import { isApiError } from '@/services/api';
import { fetchCustomerById } from '../services/customers';
import { customerKeys } from './customerKeys';

/** A 4xx is the server's settled answer, so an ungated caller spends one
 *  request rather than four. */
const isClientError = (error: unknown): boolean =>
    isApiError(error) && error.status !== undefined && error.status >= 400 && error.status < 500;

export function useCustomerQuery(id: string | undefined) {
    return useQuery({
        queryKey: customerKeys.detail(id ?? ''),
        queryFn: () => fetchCustomerById(id!),
        enabled: !!id,
        retry: (failureCount, error) => !isClientError(error) && failureCount < 2,
    });
}
